import { render, staticRenderFns } from "./Customercard.vue?vue&type=template&id=b163a3d2&"
import script from "./Customercard.vue?vue&type=script&lang=js&"
export * from "./Customercard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports